/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
// Vue validation
import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {email, max, min, required} from 'vee-validate/dist/rules'
// axios
import axios from './axios.js'
// Filters
import './filters/filters.js'
// Theme Configurations
import '../themeConfig.js'
// Globally Registered Components
import './globalComponents.js'
// Styles: SCSS
import './assets/scss/main.scss'
// Tailwind
import '@/assets/css/main.css'
// Vue Router
import router from './router'
// Vuex Store
import store from './store/store'
// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'
// Vue Laravel acl
import laravel_acl from './plugins/laravel-acl'
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import moment from 'moment';
import VueFormulate from '@braid/vue-formulate'

// VUE IDLE
import IdleVue from 'idle-vue';
import VueNativeNotification from 'vue-native-notification'
// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'

const eventsHub = new Vue()

Vue.use(Vuesax)
Vue.use(VueFormulate, {
  uploader: axios,
  uploadUrl: '/admin/supplier/file-upload'
})

Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyC4wknUBpBv4JfmLFSd-XO9mzw3ClL3gUk',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Add a rule.
extend('required', {
  ...required,
  message: 'This field is required'
})
extend('file_required', {
  ...required,
  message: 'Please upload a file'
})
extend('min', {
  ...min,
  message: 'This field must have no less than {length} characters'
})
extend('max', {
  ...max,
  message: 'This field must have no more than {length} characters'
})

extend('tel', {
  validate: value => value.match(/^[0-9]*$/u),
  message: 'Telephone Number must not contain any letter or special character'
})

extend('four_decimal', {
  validate: value => value.match(/^[0-9]*(?:\.[0-9]{0,4})?$/u),
  message: 'Quantity must be a numeric with upto four decimal places'
})

extend('number', {
  validate: value => value.match(/^[0-9]\d*(\.\d+)?$/u),
  message: 'Value must be a valid number'
})

extend('integer', {
  validate: value => value.match(/^[+-]?\d+$/),
  message: 'Value must be a valid integer'
})

extend('two_decimal', {
  validate: value => value.match(/^[0-9]*\.[0-9]{2}$/u),
  message: 'Value must be a numeric with two decimal places'
})

extend('bank_sort_code', {
  validate: value => value.match(/^[0-9][0-9][-][0-9][0-9][-][0-9][0-9]$/u),
  message: 'Format should be XX-XX-XX'
})

extend('flash_point', {
  validate: value => value.match(/^[1-9]*(?:\.[0-9]{0,1})?$/u),
  message: 'Flash Point has to be greater than 0 and have 1 decimal places'
})

extend('ph_value', {
  validate: value => value.match(/^[0-9]*(?:\.[0-9]{0,2})?$/u),
  message: 'pH value has to be greater than 0 and have 2 decimal places'
})

extend('email', {
  ...email,
  message: 'Please enter valid email address'
})

extend('no_whitespace', {
  validate: value => value.match(/^\S*$/u),
  message: 'Password must not contain whitespace'
})
extend('min_tel', {
  validate: value => value.length > 6,
  message: 'Contact number must contain at least 7 numbers.'
})


extend('fax', {
  validate: value => value.match(/^[0-9]*$/u),
  message: 'Fax No must not contain any letter or special character'
})

extend('max_tel', {
  validate: value => value.length < 17,
  message: 'Contact number allowed only 16 numbers '
})
extend('contactNumber', {
  validate: value => value.match(/^[+]{0,1}[0-9]*$/g),
  message: 'Enter valid contact number '
})


extend('g2fa', {
  validate: value => value.length  === 6,
  message: 'Login code must include 6 numbers '
})

extend('one_uppercase', {
  validate: value => value.match(/[a-z]/),
  message: 'Password must contain at least one Lowercase character'
})
extend('one_lowercase', {
  validate: value => value.match(/[A-Z]/),
  message: 'Password must contain at least one Uppercase character'
})
extend('selected', {
  ...required,
  message: 'Select at least one clinic.'
})

extend('one_number', {
  validate: value => value.match(/[0-9]/),
  message: 'Password must contain at least one numeral'
})

extend('one_special', {
  validate: value => value.match(/[$&+,:;=?@#|'<>.^*()%!-]/),
  message: 'Password must contain at least one special character'
})

extend('positive', {
  validate: value => Number(value) > -1,
  message: 'You cannot have a negative number.'
})

extend('same_password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation should be matched'
})

extend('moq', {
  params: ['target'],
  validate (value, { target }) {
    return Number(value) >= Number(target)
  },
  message(value, { target }) {
    return `The MOQ is ${target}`
  }
})

extend('maxoq', {
  params: ['target'],
  validate (value, { target }) {
    return Number(value) <= Number(target)
  },
  message(value, { target }) {
    return `The MAXOQ is ${target}`
  }
})

extend('min_than', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) < Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must be smaller than the MaxOQ`
})

extend('continuous_range', {
  params: ['prevMax', 'rowIndex'],
  validate(value, { prevMax }) {
    if (prevMax === null || prevMax === undefined) {
      return true;
    }

    const current = Number(value);
    const prev = Number(prevMax);

    return current === prev || current === parseFloat((prev + 0.0001).toFixed(4));
  },
  message(value, { prevMax, rowIndex }) {
    const prev = Number(prevMax);
    const nextAllowed = parseFloat((prev + 0.0001).toFixed(4));
    return `Row ${rowIndex}: Min value must be ${prev} or ${nextAllowed} (no gaps or overlaps).`;
  }
});

extend('min_than_or_equal', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) <= Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must be smaller than the MaxOQ`
})
extend('max_than', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) > Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must not be larger than MaxOQ`
})
extend('max_than_or_equal', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) >= Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must not be larger than MaxOQ`
})

extend('cross_over_max', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) > Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must be larger than previous MaxOQ`
})

extend('cross_over_max_equal', {
  params: ['target'],
  validate (value, { target }) {
    if (!!target) {
      return Number(value) >= Number(target)
    } else {
      return true
    }
  },
  message: `The MOQ must be larger than or equal to previous MaxOQ`
})

extend('range_from_less_than_or_equal', {
  params: ['target'],
  validate (value, { target }) {
    if (target !== undefined && target !== null && target !== '') {
      return Number(value) <= Number(target)
    }
    return true
  },
  message: 'The From value must not be greater than To value'
})

extend('range_to_greater_than_or_equal', {
  params: ['target'],
  validate (value, { target }) {
    if (target !== undefined && target !== null && target !== '') {
      return Number(value) >= Number(target)
    }
    return true
  },
  message: 'The To value must not be less than From value'
})

extend('range_cross_over_equal', {
  params: ['target'],
  validate (value, { target }) {
    if (target !== undefined && target !== null && target !== '') {
      return Number(value) >= Number(target)
    }
    return true
  },
  message: 'The From value must be greater than or equal to previous To value'
})

extend('range_cross_over_greater', {
  params: ['target'],
  validate (value, { target }) {
    if (target !== undefined && target !== null && target !== '') {
      return Number(value) > Number(target)
    }
    return true
  },
  message: 'The From value must be greater than previous To value'
})

extend('min_qty', {
  params: ['target'],
  validate (value, { target }) {
    return Number(value) <= Number(target)
  },
  message(value, { target }) {
    return `The value should be less than or equal to ${target}`
  }
})

extend('max_qty', {
  params: ['target'],
  validate(value, { target }) {
    return Number(value) <= Number(target);
  },
  message: (fieldName, { target }) => {
    return `The value must be less than or equal to ${target}`;
  }
});

extend('unique_date',{
  params: ['compare_date'],
  validate (value,{ compare_date }){
    return value !== compare_date
  },
  message:'date need to be unique'
})

extend('max_number', {
  params: ['target'],
  validate( value, { target } ){
    return Number(target) >= Number(value)
  },
  message: 'This field must not be larger than {target}.'
})

extend('upper_case', {
  validate: value => value === value.toUpperCase(),
  message: 'Please input only uppercase letters in this field'
})

extend('net_weight', {
  params: ['target'],
  validate (value, { target }) {
    return Number(value) <= Number(target)
  },
  message(value, { target }) {
    return `Net weight be lower than gross weight`
  }
})

extend("after_date", {
  params: ["target", "targetName"],
  validate(value, { target }) {
    if (!value || !target) return true;

    const parseDMY = (dateStr) => {
      const [day, month, year] = dateStr.split("/");
      return new Date(year, month - 1, day);
    };

    const valueDate = parseDMY(value);
    const targetDate = parseDMY(target);

    return valueDate >= targetDate;
  },
  message: "This date must be after {targetName}",
});

extend('date_range_max_months', {
  params: ['from', 'months'],

  validate(value, { from, months }) {
    if (!from || !value) {
      return true
    }

    const fromDate = moment(from, 'DD/MM/YYYY')
    const toDate = moment(value, 'DD/MM/YYYY')
    const maxDate = fromDate.clone().add(Number(months), 'months')

    return toDate.isSameOrBefore(maxDate, 'day')
  },

  message: 'The date range cannot be more than {months} months'
})


// Register it globally
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

Vue.mixin({
  methods: {
    __dateTimeFormatter:function(Date){
      if(Date){
        // return moment(Date).format("DD-MMM-YYYY HH:MM")
        return moment.utc(Date).local().format('DD/MM/YYYY HH:mm:ss')
      }
      else{
        return ""
      }
    },
    __dateTimeFormatterToDate:function(Date){
      if(!Date) { return '' }
      let reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
      if (Date.match(reg)) {
        return Date
      } else {
        return moment.utc(Date).local().format('DD/MM/YYYY')
      }
    },
    __dateTimeFormatterToTime: function(Date) {
      if (!Date) { return '' }   
      let reg = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
      if (Date.match(reg)) {
        return Date
      } else {
        return moment.utc(Date).local().format('HH:mm:ss')
      }
    },
    __utcToLocalTime(time){
      if(time) {
        return moment.utc(time, 'HH:mm').local().format('HH:mm')
      } else {
        return "00:00"
      }
    },
    __nameSplitter: function(link) {
      if (link) {
        let fields = link.split('/');
        const file_full_name = fields[fields.length - 1]
        let second_field =  file_full_name.split('-').slice(1).join('-')
        return second_field.replaceAll('%20', ' ')
      } else {
        return 'No file uploaded'
      }
    },
    __isCurrencyGbp(currency) {
      return currency === 'GBP'
    },
    __currencySymbol(currency) {
      const filter = Vue.filter('currency_code_formatter')
      return filter ? filter(currency) : ''
    },
    __removeTrailingZeros(number) {
      let numberString = number.toString();
      numberString = numberString.replace(/\.?0+$/, '');
      return parseFloat(numberString);
    }
  }
})


Vue.prototype.$http = axios

axios.interceptors.response.use(
  response => {
    return Promise.resolve(response);
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 403:
          router.push('/').then(() => { location.reload() })
        // case 401:
        //   router.push('/').then(() => { location.reload() })
      }
    }
    return Promise.reject(error);
  }
);

Vue.filter('currency', function (value) {
  if (!value) return 'N/A'
  return Number(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
})

Vue.use(VueHammer)

Vue.use(laravel_acl, router)

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3600000,
  startAtIdle: false
});

Vue.use(VueNativeNotification, {
  requestOnNotify: true
})

// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
